import React, { useState, useEffect, useRef } from 'react'
import { useParams } from "react-router-dom"
import axios from 'axios'
import style from './HousingModels.module.scss'
import { Container, Row, Col } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import Footer from './../../UIComponents/Footer/Footer'
import Header from './../../UIComponents/Header/Header'
import Card from './../../UIComponents/Housing/Card'
import Slider from './Slider'
import { NavLink } from "react-router-dom";

const  HouseModel = () => {

    const { t, i18n } = useTranslation('common')
    const [data, setData] = useState()
    const { modelId } = useParams()
    const [slider, setSlider] = useState(1)

    useEffect(() => {
        handleDetails()
    }, [modelId])

    const handleDetails = async() => {
        const res =  await axios.post(
            `${process.env.REACT_APP_API_URL}/PORTAL/APPROVINGCHARTS/GET_APPROVING_CHART_INFO`,
            {
                'Approving_Chart_Id': modelId
            }
        )
        setData(res.data.Data)
    }

    const handleDownload = val => {
        console.log(val)
        let a = document.createElement("a"); // Create <a>
        a.href = val; // val
        a.target = '_blank';
        a.download = val; // File name 
        a.click(); // Download file
    }

    return (
        <>
            <Header />

            <Container>
                <Row  className={style.header}>
                    <Col md={6} className='d-flex align-items-center'>
                        <p className={style.title}>
                            <NavLink to={"/"}>
                                {t("menu_home")}
                            </NavLink>
                            /
                            <NavLink to='/housing_models'>
                                {t("Housing Models")}
                            </NavLink>
                            /
                            {data?.Main_Chart_Data?.Approving_Chart_Name}
                        </p>
                    </Col>

                    <Col md={6} className='d-flex justify-content-md-end justify-content-center'>
                        <div 
                            className={[
                                style.sliderIcons,
                                slider === 1 ? style.sliderIconsActive : false
                            ].join(' ')} 
                            onClick={() => setSlider(1)}
                        >
                            <svg width="32px" height="25px" viewBox="0 0 32 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                <title>home</title>
                                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="3" transform="translate(-549.000000, -350.000000)" fill="#000000" fillRule="nonzero">
                                        <g id="Group-2" transform="translate(536.000000, 333.000000)">
                                            <g id="home" transform="translate(13.887324, 17.971831)">
                                                <path d="M15.112727,4.78219941 L4.33299476,13.5346364 C4.33299476,13.5469889 4.32984285,13.5651618 4.32353903,13.5899313 C4.31736653,13.6145068 4.31408329,13.6323564 4.31408329,13.6450322 L4.31408329,22.5078003 C4.31408329,22.8277993 4.43287094,23.1051145 4.67038055,23.3386464 C4.90782451,23.5723078 5.18900122,23.6898822 5.51397637,23.6898822 L12.7128095,23.6898822 L12.7128095,16.5994607 L17.5127101,16.5994607 L17.5127101,23.6901408 L24.7114776,23.6901408 C25.036387,23.6901408 25.3179577,23.5728251 25.5550734,23.3386464 C25.792583,23.1053732 25.9117646,22.827864 25.9117646,22.5078003 L25.9117646,13.6450322 C25.9117646,13.5958812 25.9049355,13.5587592 25.8928532,13.5346364 L15.112727,4.78219941 Z" id="Path"></path>
                                                <path d="M30.0168659,11.5403988 L25.9113706,8.17989243 L25.9113706,0.646400474 C25.9113706,0.474177917 25.8551616,0.332545397 25.7423494,0.221696931 C25.6304566,0.11097781 25.4866506,0.0556182499 25.3113913,0.0556182499 L21.711909,0.0556182499 C21.5368467,0.0556182499 21.3931064,0.11097781 21.2804912,0.221696931 C21.1681387,0.332545397 21.1119953,0.474242589 21.1119953,0.646400474 L21.1119953,4.24690609 L16.5376533,0.480063104 C16.1381486,0.159999477 15.6631294,-9.19049848e-16 15.113121,-9.19049848e-16 C14.5631782,-9.19049848e-16 14.0882246,0.159999477 13.6883259,0.480063104 L0.208325383,11.5403988 C0.08336525,11.6387008 0.0148768532,11.7710205 0.00213788007,11.9372286 C-0.0105354283,12.1033073 0.0331316704,12.2483674 0.133270506,12.3713743 L1.29560331,13.7377724 C1.39574214,13.8484915 1.5268091,13.9162035 1.68932951,13.940973 C1.8393736,13.9533901 1.98941769,13.910189 2.13946178,13.8117576 L15.112727,3.15749979 L28.0861235,13.8116929 C28.186328,13.8975779 28.3173293,13.9404557 28.4798497,13.9404557 L28.5361901,13.9404557 C28.6984478,13.9161388 28.8292521,13.8479741 28.9299163,13.7375137 L30.0923804,12.3713096 C30.1923223,12.248044 30.2361207,12.1032426 30.2231191,11.9369699 C30.2103144,11.7712146 30.1415634,11.6388949 30.0168659,11.5403988 Z" id="Path"></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>

                        <div
                            className={[
                                style.sliderIcons,
                                slider === 2 ? style.sliderIconsActive : false
                            ].join(' ')} 
                            onClick={() => setSlider(2)}
                        >
                            <svg width="32px" height="25px" viewBox="0 0 32 25" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                <title>plan</title>
                                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="3" transform="translate(-459.000000, -350.000000)" fill="#FFFFFF" fillRule="nonzero">
                                        <g id="Group-3" transform="translate(446.000000, 333.000000)">
                                            <g id="plan" transform="translate(13.070423, 17.154930)">
                                                <path d="M18.9580366,11.1767022 C18.2898694,11.4580267 17.5358884,11.4589531 16.8667886,11.1794815 L15.2357022,14.4670557 L20.5875683,14.4670557 L18.9580366,11.1767022 Z" id="Path"></path>
                                                <path d="M17.9089924,10.2811579 C18.7749046,10.2811579 19.476962,9.58386856 19.476962,8.72383712 C19.476962,7.86349697 18.7749046,7.16620766 17.9089924,7.16620766 C17.0430802,7.16620766 16.3410228,7.86349697 16.3410228,8.72383712 C16.3419556,9.58355969 17.0433911,10.2802314 17.9089924,10.2811579 Z" id="Path"></path>
                                                <path d="M5.41249549,17.4711438 L5.41249549,0 L2.78459958,0 C1.25083121,0.0114258909 0.0108822202,1.24388022 0,2.76692322 L0,18.6353514 C0.733771217,17.8923584 1.73679912,17.4729967 2.78459958,17.4711438 L5.41249549,17.4711438 Z" id="Path"></path>
                                                <path d="M6.52683279,18.0328663 C6.53118571,18.1767709 6.47646379,18.3160435 6.37510383,18.4188767 C6.27405485,18.5214011 6.13507358,18.5791483 5.99018482,18.577913 L2.78459958,18.577913 C1.30866229,18.58131 0.0895449621,19.7235922 0,21.1867264 L0,21.9111908 C0.0907886421,23.3718546 1.31114965,24.5095047 2.78459958,24.5070383 L31.0422535,24.5070383 L31.0422535,2.98803003 L6.52683279,2.83331704 L6.52683279,18.0328663 Z M11.3025641,14.1480566 C11.3025641,13.8423363 11.5519219,13.594672 11.8597328,13.594672 C12.1675436,13.594672 12.4169014,13.8423363 12.4169014,14.1480566 L12.4169014,14.4670557 L13.9935768,14.4670557 L15.943978,10.535616 C15.2866931,9.83307688 15.0603433,8.83377299 15.3516754,7.91939127 C15.6430074,7.00500963 16.4069378,6.31667574 17.3518238,6.11780314 L17.3518238,5.24912514 C17.3518238,4.94371358 17.6011816,4.6957405 17.9089924,4.6957405 C18.2168033,4.6957405 18.4661611,4.94371358 18.4661611,5.24912514 L18.4661611,6.11811192 C19.4094923,6.31667574 20.172801,7.00315682 20.4650658,7.91568557 C20.7576415,8.82852319 20.5340901,9.82659192 19.8796034,10.5300575 L21.8293828,14.4670557 L23.4010834,14.4670557 L23.4010834,14.1480566 C23.4010834,13.8423363 23.6504412,13.594672 23.9582521,13.594672 C24.2660629,13.594672 24.5154207,13.8423363 24.5154207,14.1480566 L24.5154207,15.9076468 C24.5154207,16.2133672 24.2660629,16.4610315 23.9582521,16.4610315 C23.6504412,16.4610315 23.4010834,16.2133672 23.4010834,15.9076468 L23.4010834,15.573825 L22.3778457,15.573825 L24.1687449,19.2128231 C24.2959112,19.4793248 24.3602716,19.7714575 24.3562297,20.0663695 L24.3562297,21.6295576 C24.3562297,21.9349691 24.1068719,22.1829422 23.799061,22.1829422 C23.4912502,22.1829422 23.2418924,21.9349691 23.2418924,21.6295576 L23.2418924,20.0663695 C23.2459343,19.9406845 23.2207498,19.8159259 23.1685153,19.701358 L21.1357202,15.573825 L14.6866175,15.573825 L12.6497805,19.7016668 C12.597235,19.8159259 12.5720505,19.9409933 12.5760925,20.0666783 L12.5760925,21.6295576 C12.5760925,21.9349691 12.3267346,22.1829422 12.0189238,22.1829422 C11.711113,22.1829422 11.4617551,21.9349691 11.4617551,21.6295576 L11.4617551,20.0663695 C11.4580241,19.7711487 11.5223846,19.4787071 11.6501727,19.2118967 L13.4441811,15.573825 L12.4169014,15.573825 L12.4169014,15.9076468 C12.4169014,16.2133672 12.1675436,16.4610315 11.8597328,16.4610315 C11.5519219,16.4610315 11.3025641,16.2133672 11.3025641,15.9076468 L11.3025641,14.1480566 Z" id="Shape"></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>

                        <div
                            className={[
                                style.sliderIcons,
                                slider === 3 ? style.sliderIconsActive : false
                            ].join(' ')} 
                            onClick={() => setSlider(3)}
                        >
                            <svg width="34px" height="34px" viewBox="0 0 34 34" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                <title>color-palette</title>
                                <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="3" transform="translate(-374.000000, -345.000000)" fillRule="nonzero">
                                        <g id="Group-4" transform="translate(363.000000, 333.000000)">
                                            <g id="color-palette" transform="translate(11.436620, 12.253521)">
                                                <ellipse id="Oval" fill="#56753C" cx="16.7470823" cy="6.9350777" rx="1" ry="1"></ellipse>
                                                <ellipse id="Oval" fill="#56753C" cx="15.7658079" cy="25.5812772" rx="1.9625487" ry="1.96275784"></ellipse>
                                                <ellipse id="Oval" fill="#56753C" cx="7.9156131" cy="19.6930037" rx="1.9625487" ry="1.96275784"></ellipse>
                                                <ellipse id="Oval" fill="#56753C" cx="8.89688745" cy="10.8605934" rx="1" ry="1"></ellipse>
                                                <path d="M16.7470823,0 C7.41509776,0 0,7.64710082 0,16.7488669 C0,26.1949007 7.73401193,33.4929577 16.4557746,33.4929577 C20.1048723,33.4929577 23.2096897,30.7795105 23.5757705,27.3092237 C23.7079808,26.0643119 23.5067542,24.8135772 22.9892955,23.6904217 C22.5427502,22.7214736 22.9068685,21.8417001 23.3956085,21.3423745 C23.8843485,20.8421329 24.7582715,20.463517 25.7376487,20.8881269 C27.5740709,21.7682929 28.6689114,21.7342718 29.5767865,21.5589975 C31.8363996,21.1133207 33.5191543,18.9675684 33.492649,16.5667884 C33.3945325,7.46796645 25.8468972,0 16.7470823,0 Z M8.89688745,7.91645662 C10.5201769,7.91645662 11.8407105,9.23713094 11.8407105,10.8605934 C11.8407105,12.4840558 10.5201769,13.8047301 8.89688745,13.8047301 C7.273598,13.8047301 5.9530644,12.4840558 5.9530644,10.8605934 C5.9530644,9.23713094 7.273598,7.91645662 8.89688745,7.91645662 Z M7.9156131,23.6185193 C5.75183774,23.6185193 3.99051569,21.857991 3.99051569,19.6930037 C3.99051569,17.5280163 5.75183774,15.767488 7.9156131,15.767488 C10.0793885,15.767488 11.8407105,17.5280163 11.8407105,19.6930037 C11.8407105,21.857991 10.0793885,23.6185193 7.9156131,23.6185193 Z M15.7658079,29.5067929 C13.6020325,29.5067929 11.8407105,27.7462645 11.8407105,25.5812772 C11.8407105,23.4162899 13.6020325,21.6557615 15.7658079,21.6557615 C17.9295833,21.6557615 19.6909053,23.4162899 19.6909053,25.5812772 C19.6909053,27.7462645 17.9295833,29.5067929 15.7658079,29.5067929 Z M16.7470823,9.87921446 C15.1237928,9.87921446 13.8032592,8.55854013 13.8032592,6.9350777 C13.8032592,5.31161526 15.1237928,3.99094094 16.7470823,3.99094094 C18.3703717,3.99094094 19.6909053,5.31161526 19.6909053,6.9350777 C19.6909053,8.55854013 18.3703717,9.87921446 16.7470823,9.87921446 Z M24.5972771,13.8047301 C22.9739876,13.8047301 21.653454,12.4840558 21.653454,10.8605934 C21.653454,9.23713094 22.9739876,7.91645662 24.5972771,7.91645662 C26.2205665,7.91645662 27.5411001,9.23713094 27.5411001,10.8605934 C27.5411001,12.4840558 26.2205665,13.8047301 24.5972771,13.8047301 Z" id="Shape" fill="#000000"></path>
                                                <ellipse id="Oval" fill="#56753C" cx="24.5972771" cy="10.8605934" rx="1" ry="1"></ellipse>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <Slider slider={slider} data={data} />
                    </Col>
                </Row>

                <Row className={style.detailsTitle}>
                    <Col md={6}>
                        <p className={style.title}>{t('All the details')}</p>
                    </Col>
                    <Col 
                        md={6} 
                        className={style.download}
                    >
                        <span className={style.downloadIcon} onClick={() => handleDownload(data.Main_Chart_Data.Approving_Chart_File_Url)}>
                            <svg height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px">
                                <g id="Solid">
                                    <path d="m239.029 384.97a24 24 0 0 0 33.942 0l90.509-90.509a24 24 0 0 0 0-33.941 24 24 0 0 0 -33.941 0l-49.539 49.539v-262.059a24 24 0 0 0 -48 0v262.059l-49.539-49.539a24 24 0 0 0 -33.941 0 24 24 0 0 0 0 33.941z"/>
                                    <path d="m464 232a24 24 0 0 0 -24 24v184h-368v-184a24 24 0 0 0 -48 0v192a40 40 0 0 0 40 40h384a40 40 0 0 0 40-40v-192a24 24 0 0 0 -24-24z"/>
                                </g>
                            </svg>
                        </span>
                        <p className={style.title}>{t('Download designs')}</p>
                    </Col>
                </Row>

                <Row className={style.details}>
                    <Col sm={12} className={[style.coloredRow, style.detailRow].join(' ')}>
                        <Row>
                            <Col md={6}>{t('Consultant name')}</Col>
                            <Col md={6} className='d-flex justify-content-end'>
                                {i18n.language == 'en' ? data?.Main_Chart_Data?.Approving_Chart_Consultant_Name_EN : data?.Main_Chart_Data?.Approving_Chart_Consultant_Name_AR}
                            </Col>
                        </Row>
                    </Col>

                    <Col sm={12} className={style.detailRow}>
                        <Row>
                            <Col md={6}>{t('Bedrooms')}</Col>
                            <Col md={6} className='d-flex justify-content-end'>
                                {data?.Main_Chart_Data?.Approving_Chart_Bedroom_No}
                            </Col>
                        </Row>
                    </Col>

                    <Col sm={12} className={[style.coloredRow, style.detailRow].join(' ')}>
                        <Row>
                            <Col md={6}>{t('space')}</Col>
                            <Col md={6} className='d-flex justify-content-end'>
                                {data?.Main_Chart_Data?.Approving_Chart_Area} {t('square meter')}
                            </Col>
                        </Row>
                    </Col>

                    <Col sm={12} className={style.detailRow}>
                        <Row>
                            <Col md={6}>{t('floors no')}</Col>
                            <Col md={6} className='d-flex justify-content-end'>
                                {data?.Main_Chart_Data?.Approving_Chart_Floors_No}
                            </Col>
                        </Row>
                    </Col>
                    
                    <Col sm={12} className={[style.coloredRow, style.detailRow].join(' ')}>
                        <Row>
                            <Col md={6}>{t('House dimensions')}</Col>
                            <Col md={6} className='d-flex justify-content-end'>
                                {data?.Main_Chart_Data?.Approving_Chart_Length} {t('meter')} x 18.40
                            </Col>
                        </Row>
                    </Col>

                    <Col sm={12} className={style.detailRow}>
                        <Row>
                            <Col md={6}>{t('Special Features')}</Col>
                            <Col md={6} className='d-flex justify-content-end'>
                                {i18n.language == 'ar' ? data?.Main_Chart_Data?.Approving_Chart_Special_Advantages_AR : data?.Main_Chart_Data?.Approving_Chart_Special_Advantages_EN}
                            </Col>
                        </Row>
                    </Col>

                    <Col sm={12} className={[style.coloredRow, style.detailRow].join(' ')}>
                        <Row>
                            <Col md={6}>{t('air conditioning type')}</Col>
                            <Col md={6} className='d-flex justify-content-end'>
                                {i18n.language == 'ar' ? data?.Main_Chart_Data?.Approving_Chart_AC_Type_AR : data?.Main_Chart_Data?.Approving_Chart_AC_Type_EN}

                            </Col>
                        </Row>
                    </Col>

                    <Col sm={12} className={style.detailRow}>
                        <Row>
                            <Col md={6}>{t('Accreditation')}</Col>
                            <Col md={6} className='d-flex justify-content-end'>
                                {data?.Main_Chart_Data?.Active_Status_Id == '1' ? <>{t('pre-approved')}</> : <>{t('not approved')}</>}
                            </Col>
                        </Row>
                    </Col>
                
                    <Col sm={12} className={[style.coloredRow, style.detailRow].join(' ')}>
                        <Row>
                            <Col md={6}>{t('Ceiling height')}</Col>
                            <Col md={6} className='d-flex justify-content-end'>
                                {data?.Main_Chart_Data?.Approving_Chart_Height} {t('Area')}

                            </Col>
                        </Row>
                    </Col>
                </Row>

                <Card limited={true} />
            </Container>

            <Footer />
        </>
    )
}

export default HouseModel
